module.exports = __webpack_public_path__ + "img/logo_kto@3x.54f76cec.png";